import { styled } from 'styled-components';
import type { GaugeProps } from '../../common';
import { GaugeArc, StyledGaugeWrapper } from '../../common';

const SIZE = 48;
const THICKNESS = 3;

export function Gauge({ score }: GaugeProps) {
  return (
    <GaugeWrapper
      $width={SIZE}
      $height={SIZE}
      $score={score}
      $backgroundOpacity={0.1}
    >
      <GaugeArc
        size={SIZE}
        thickness={THICKNESS}
        score={score}
        percentageStyle={{
          fontSize: '16px',
          fontWeight: 700,
          lineHeight: '22px'
        }}
      />
    </GaugeWrapper>
  );
}

const GaugeWrapper = styled(StyledGaugeWrapper)`
  margin-top: 4px;
`;
